import DateCondition from './DateCondition'
import MonthCondition from './MonthCondition'
import TypeCondition from './TypeCondition'
import DateSelect from './DateSelect'
import Plan from './Plan'

export default {
	name: 'ReservationInput',
	components: {
		DateCondition,
		MonthCondition,
		TypeCondition,
		DateSelect
	},
	props: {
		value: {
			type: Object
		},
		leaseTimeClasses: {
			type: Array,
			default: []
		},
		availablePlans: {
			type: Array,
			default: [Plan.rent, Plan.lease]
		},
		options: {
			type: Array
		}
	},
	data () {
		const val = {
			dateFromM: null,
			option: [],
			...this.value
		}
		const dateEnabled = (val.dateFrom && val.timeFrom && val.dateTo && val.timeTo)
		const monthEnabled = !dateEnabled && (val.dateFromM || val.month)
		return {
			val,
			dateEnabled: dateEnabled || !monthEnabled,
			monthEnabled,
			Plan
		}
	},
	template: `
		<div>
			<section class="m-block-space-m">
				<h3 class="search-sub -space">貸出期間</h3>

				<DateCondition
					v-if="availablePlans.includes(Plan.rent)"
					class="m-block-space-ss"
					:class="{ 'search-cond-disabled': !dateEnabled }"
					v-model="val"
					@controlClick="dateEnabled = true; monthEnabled = false"
				/>

				<dl
					v-if="availablePlans.includes(Plan.lease)"
					class="search-data -sp-no-left"
					:class="{ 'search-cond-disabled': !monthEnabled }"
				>
					<dt class="search-data__ttl-left">月指定</dt>
					<dd>
						<div class="m-sch">
							<DateSelect v-model="val.dateFromM"
								@controlClick="dateEnabled = false; monthEnabled = true"
							/>
						</div>
						<span class="search-data__while">~</span>
						<div class="m-sch">
							<MonthCondition
								v-model="val.month"
								@controlClick="dateEnabled = false; monthEnabled = true"
								:timeClasses="leaseTimeClasses"
							/>
						</div>
					</dd>
				</dl>
			</section>

			<!-- 車両情報が入る -->
			<slot></slot>

			<section class="search-option"
				v-if="options"
			>
				<h3 class="search-sub -space -wide">追加オプション</h3>
				<p v-if="this.dateEnabled">
					追加オプションは月指定（ML）のみ利用できます。
				</p>
				<template v-else>
					<fieldset class="m-form-set -pc-only">
						<label class="m-checkbox -r-space"
							v-for="option in options"
							:key="option.id"
						>
							<input type="checkbox" :value="option.id" v-model="val.option">
							<span class="m-checkbox__ico"></span>
							{{ option.name }}
						</label>
					</fieldset>
				</template>
			</section>

			<!-- パラメータリスト -->
			<input type="hidden"
				v-for="pair in condition"
				:key="pair.index"
				:name="pair.name"
				:value="pair.value"
			/>

			<div class="search-last">
				<p><button type="submit" class="m-btn-02 -high -sp-size-l">次へ</button></p>
			</div>
		</div>
	`,
	methods: {
		clear () {
			const { val } = this
			val.dateFrom = null
			val.dateTo = null
			val.timeFrom = null
			val.timeTo = null
			val.dateFromM = null
			val.month = null
			val.option = []
			this.dateEnabled = false
			this.monthEnabled = false
		}
	},
	computed: {
		condition () {
			const { val } = this
			const cond = []
			if (!this.dateEnabled && !this.monthEnabled) return null
			if (this.dateEnabled) {
				cond.push(
					['dateFrom', val.dateFrom],
					['timeFrom', val.timeFrom],
					['dateTo', val.dateTo],
					['timeTo', val.timeTo]
				)
			} else if (this.monthEnabled) {
				cond.push(
					['dateFrom', val.dateFromM],
					['month', val.month]
				)
				val.option.forEach(optionId => {
					cond.push(['option[]', optionId])
				})
			}
			if (val.type) {
				cond.push(['type', val.type])
			}
			return cond.map((pair, index) => {
				return {
					index,
					name: pair[0],
					value: pair[1]
				}
			})
		},
		filled () {
			const { val } = this
			if (this.dateEnabled) {
				return val.dateFrom && val.dateTo && val.timeFrom && val.timeTo
			} else if (this.monthEnabled) {
				return val.dateFromM && val.month
			} else {
				return false
			}
		}
	},
	watch: {
		val: {
			deep: true,
			handler () {
				this.$emit('input', this.val)
			}
		}
	}
}
